import React from 'react';
import ReactDOM from 'react-dom/client';
import 'rc-slider/assets/index.css';
import './index.css';
import App from './App';


import { createWeb3Modal, defaultWagmiConfig } from '@web3modal/wagmi/react'
import { WagmiConfig } from 'wagmi'
import { mainnet, sepolia } from 'viem/chains'

// 1. Get projectId at https://cloud.walletconnect.com
const projectId = 'f9d0a5e839e3757042120d3bac7c88bc' // Project ID , 
// const projectId = 'f9d0a5e839e3757042120d3bac7c88bc'



// 2. Create wagmiConfig
const metadata = {
  name: 'SVO Presale ',
  description: 'SVO Presale',
  url: 'https://svozero.netlify.app/',
  icons: ['https://avatars.githubusercontent.com/u/37784886']
}
const chains = [mainnet]
const wagmiConfig = defaultWagmiConfig({ chains, projectId, metadata })

// 3. Create modal
createWeb3Modal({ wagmiConfig, projectId, chains })


const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
   <WagmiConfig config={wagmiConfig}>
      <App />
    </WagmiConfig>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
// reportWebVitals();
